<template>
  <div class="success-block">
    <transition name="slide-x-transition">
      <div v-if="show">
        <div class="inner justify-end">
          <p>{{ title }}</p>
          <div class="success-checkmark">
            <div class="check-icon">
              <span class="icon-line line-tip"></span>
              <span class="icon-line line-long"></span>
              <div class="icon-circle"></div>
              <div class="icon-fix"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'success',
  props: {
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/success.vue